import React, { useState } from 'react'
import { Button, Input, Form, Col, Typography } from 'antd'
import { LockOutlined, UserOutlined } from '@ant-design/icons'
import packageJson from '../../../package.json'

import './index.css'
import { getApi, errorMessage } from '../../helpers'
import { canUseDashboard } from '../../helpers/permissions'
import { takeSessionEndRecord } from '../../helpers/session'

// One login for everyone: username, mobile or email plus password. The
// role in the response decides which pages the user sees.
export default function Login({ setToken }) {
  const [loading, setLoading] = useState(false)

  const loginHandler = async (values) => {
    setLoading(true)
    const res = await getApi(values, 'loginUser', 'mobile/', {})
    if (res.data) {
      // Customers (and unknown roles) have no dashboard access.
      if (!canUseDashboard(res.data.role_id)) {
        errorMessage("This account can't use the dashboard.")
        setLoading(false)
        return
      }

      // Store role_id and user data FIRST before token
      localStorage.setItem("user_role_id", String(res.data.role_id))
      localStorage.setItem("user_data", JSON.stringify(res.data))

      // After a session ended, only return to that page if it's the same person.
      const ended = takeSessionEndRecord()
      if (ended?.userId != null && String(ended.userId) !== String(res.data.id)) {
        window.history.replaceState(null, '', '/')
      }

      // Store token (this triggers the auth redirect)
      setToken(res.data.token)

      setTimeout(() => {
        setLoading(false)
      }, 1000)
    } else {
      setLoading(false)
    }
  }

  return (
    <div className='login-wrapper'>
      <div className='login-one' />
      <div className='login-two'>
        <div className='login-logo' />
        <h1 className='login-title'>Welcome</h1>
        <Form
          name='login'
          initialValues={{ remember: true }}
          onFinish={loginHandler}
          layout="vertical"
          requiredMark={false}
        >
          <Col span={24}>
            <Form.Item
              name='username'
              rules={[
                { required: true, message: 'Please enter your username!' },
              ]}
              // label='Username'
            >
              <Input
                style={{ borderRadius: 6 }}
                size='large'
                // maxLength={10}
                prefix={<UserOutlined className='login-input-icon' />}
                placeholder='Username'
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              name='password'
              rules={[
                { required: true, message: 'Please enter your password!' },
              ]}
              // label='Password'
            >
              <Input
                style={{ borderRadius: 6 }}
                size='large'
                prefix={<LockOutlined className='login-input-icon' />}
                type='password'
                placeholder='Password'
              />
            </Form.Item>
          </Col>
          {/* <Form.Item>
            <Form.Item name="remember" valuePropName="checked" noStyle>
              <Checkbox>Remember me</Checkbox>
            </Form.Item>
            <a className="login-form-forgot" href="">
              Forgot password
            </a>
          </Form.Item> */}
          <Col span={24}>
            <Form.Item>
              <Button
                size='large'
                loading={loading}
                type='primary'
                htmlType='submit'
                className='login-btn'
              >
                LOGIN
              </Button>
            </Form.Item>
          </Col>
        </Form>

        {/* Version Number */}
        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          <Typography.Text
            style={{
              color: '#8c8c8c',
              fontSize: '12px',
              opacity: 0.7
            }}
          >
            Version {packageJson.version}
          </Typography.Text>
        </div>
      </div>
    </div>
  )
}
